import { useMonyawn } from "../../../context/MonyawnContext";
import { OpportunityCockpit } from "../../features/opportunities/OpportunityCockpit";
import { AdminOverview } from "./sections/AdminOverview";
import { ReleaseControls } from "./sections/ReleaseControls";
import { EnterpriseControls } from "./sections/EnterpriseControls";
import { GovernanceAudit } from "./sections/GovernanceAudit";
import { useDataTransformOps } from "../../../hooks/useDataTransformOps";
import { useOpportunityOps } from "../../../hooks/useOpportunityOps";
import { isClosedStage } from "../../../workflow";
import { createSeedState } from "../../../seed";
import { ChatShell } from "../../chat/ChatShell";
import { GlobalOpsHero } from "../../features/ops/GlobalOpsHero";
import { PanelGuard } from "../../../lib/panel";
import { HeroSection } from "./sections/HeroSection";
import { NoActivePlaySection } from "./sections/NoActivePlaySection";

export function WorkspacePage() {
  const { state, selectedOpportunity, completionScore, notice, setCurrentPage, patchState } =
    useMonyawn();

  const {
    handleExport,
    handleImport,
    resetSeedState,
    handlePremiumDiligencePacketExport,
    handleSharePlay,
  } = useDataTransformOps();
  const { handleAdvanceStage, handleCloseLost } = useOpportunityOps();

  const guardResult = selectedOpportunity
    ? PanelGuard.validateEvidenceDepth(selectedOpportunity, state)
    : { passed: true, failures: [] };

  if (!selectedOpportunity) {
    return (
      <main
        id="main-content"
        className="motion-fade-up max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 xl:px-10 py-8 sm:py-10 lg:py-12 w-full min-h-screen"
      >
        <NoActivePlaySection
          notice={notice}
          onStartNewPlay={() => {
            window.location.hash = "setup-base";
            setCurrentPage("setup-base");
          }}
          onImportZip={handleImport}
          onLoadMockBag={() => patchState(() => createSeedState(), "Demo data loaded.")}
        />
      </main>
    );
  }

  return (
    <main
      id="main-content"
      className="motion-fade-up max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 xl:px-10 py-8 sm:py-10 lg:py-12 w-full min-h-screen"
    >
      <GlobalOpsHero />
      <HeroSection
        currentMode={state.currentMode}
        completionScore={completionScore}
        currentStage={selectedOpportunity.current_stage}
        notice={notice}
        guardResult={guardResult}
        isCloseLostDisabled={isClosedStage(selectedOpportunity.current_stage)}
        onAdvanceStage={handleAdvanceStage}
        onExport={handleExport}
        onPremiumDiligencePacketExport={handlePremiumDiligencePacketExport}
        onSharePlay={handleSharePlay}
        onCloseLost={handleCloseLost}
        onResetSeedState={resetSeedState}
      />

      {/* Workflow cockpit */}
      <OpportunityCockpit />

      {/* User mode — chat shell */}
      {state.currentMode === "user" && (
        <div className="mt-8 pb-24">
          <ChatShell />
        </div>
      )}

      {/* Admin mode — control panels */}
      {state.currentMode === "admin" && (
        <div className="flex flex-col gap-12 mt-8 pb-24">
          <AdminOverview />
          <ReleaseControls />
          <EnterpriseControls />
          <GovernanceAudit />
        </div>
      )}
    </main>
  );
}
